const customer_exit_messages = {
  title: ['customer_exit>>title', 'Customer exit'],
  description: ['customer_exit>>description', 'Search for a customer, review export scope and create a logged data exit package.'],
  search_label: ['customer_exit>>search_label', 'Search customer'],
  search_button: ['customer_exit>>search_button', 'Search'],
  create_export: ['customer_exit>>create_export', 'Create exit package'],
  customer_details: ['customer_exit>>customer_details', 'Customer details'],
  activity_log: ['customer_exit>>activity_log', 'Exit activity log'],
  no_customer_selected: ['customer_exit>>no_customer_selected', 'Search and select a customer to view exit details.'],
  organization: ['customer_exit>>organization', 'Organization'],
  organization_number: ['customer_exit>>organization_number', 'Registration number'],
  status: ['customer_exit>>status', 'Status'],
  created: ['customer_exit>>created', 'Created'],
  contact_name: ['customer_exit>>contact_name', 'Contact name'],
  contact_email: ['customer_exit>>contact_email', 'Contact email'],
  action_templates: ['customer_exit>>action_templates', 'Action templates'],
  asset_action_instances: ['customer_exit>>asset_action_instances', 'Asset action instances'],
  incidents: ['customer_exit>>incidents', 'Incidents'],
  dsar_cases: ['customer_exit>>dsar_cases', 'DSAR cases'],
  dsar_asset_cases: ['customer_exit>>dsar_asset_cases', 'DSAR asset cases'],
  assets: ['customer_exit>>assets', 'Assets'],
  employees: ['customer_exit>>employees', 'Employees'],
  export_dialog_title: ['customer_exit>>export_dialog_title', 'Create exit package'],
  export_dialog_text: [
    'customer_exit>>export_dialog_text',
    'Add the mandatory reason or ticket reference before creating the ZIP package.',
  ],
  comment: ['customer_exit>>comment', 'Comment'],
  cancel: ['customer_exit>>cancel', 'Cancel'],
  confirm: ['customer_exit>>confirm', 'Create and download'],
  action: ['customer_exit>>action', 'Action'],
  performed_by: ['customer_exit>>performed_by', 'Performed by'],
  query: ['customer_exit>>query', 'Query'],
  export_id: ['customer_exit>>export_id', 'Export ID'],
  timestamp: ['customer_exit>>timestamp', 'Timestamp'],
  export_created: ['customer_exit>>export_created', 'Exit package created.'],
};

export default customer_exit_messages;
